import { render, staticRenderFns } from "./PostedIcon.vue?vue&type=template&id=c24a6c76&scoped=true&"
import script from "./PostedIcon.vue?vue&type=script&lang=js&"
export * from "./PostedIcon.vue?vue&type=script&lang=js&"
import style0 from "./PostedIcon.vue?vue&type=style&index=0&id=c24a6c76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24a6c76",
  null
  
)

export default component.exports